import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./DashBoard.module.scss";
import {
  AccountBalance,
  AutoGraph,
  CrisisAlert,
  CurrencyRupee,
  CurrencyRupeeOutlined,
  Description,
  HourglassBottom,
  HourglassTop,
  People,
  QueryStats,
  ReceiptLong,
  ShowChart,
  Storefront,
  TableChart,
  ViewInAr,
  Web,
} from "@mui/icons-material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MovingIcon from "@mui/icons-material/Moving";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import { DashboardTile } from "../../components/uiComponents/dashBoardTile/DashBoardTile";

import PeopleIcon from "@mui/icons-material/People";
// import { connect, useDispatch } from "react-redux";

import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Slide,
  Slider,
  Typography,
} from "@mui/material";
import MiniStat from "../../components/uiComponents/miniStat/MiniStat";
import { connect, useDispatch } from "react-redux";
import {
  getAllCategory,
  getAllProduct,
  getAllStates,
  getCancelledCount,
  getDeliveredCount,
  getPackedCount,
  getPendingCount,
  getProductByCategoryId,
  getShippedCount,
  getTopSellingProducts,
  getTotalOrders,
  getTotalSales,
} from "../../store/actions";
import ProductStocks from "../../components/uiComponents/productStocks/ProductStocks";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";
// import ProductStocks from "../../components/uiComponents/productStocks/ProductStocks";

const columns = [
  { id: 1, label: "S.NO", minWidth: 120, align: "center" },
  { id: 2, label: "Image", minWidth: 170, align: "center" },
  { id: 3, label: "Product Id", minWidth: 170, align: "center" },
  // { id: 4, label: "SKU", minWidth: 170, align: "center" },
  { id: 5, label: "Product Name", minWidth: 170, align: "center" },
  { id: 6, label: "Category", minWidth: 170, align: "center" },
  { id: 7, label: "In stock", minWidth: 170, align: "center" },
  { id: 8, label: "Unit Sold", minWidth: 170, align: "center" },
  { id: 9, label: "Revenue", minWidth: 170, align: "center" },
];
const Dashboard = ({
  totalSale = {},
  totalOrder = {},
  topSellingProducts = [],
  pendingCount = {},
  cancelledCount = {},
  shippedCount = {},
  packedCount = {},
  deliveredCount = {},
  categories = [],
  productbyCategoryId = [],
  products = [],
}) => {
  const dispatch = useDispatch();
  const [miniStatData, setMiniStatData] = useState([]);

  useEffect(() => {
    const handleSale = (salesData) => {
      const handleData = (orderData) => {
        setMiniStatData([
          {
            id: "1",

            icon: <MovingIcon name="show-chart" size={24} color="black" />,
            infoTitle: "Total Sales",
            info: salesData || 0,
            bg: "rgba(0, 0, 255, 0.1)",
            color: "black",
          },
          {
            id: "2",
            icon: (
              <AccountBalanceWalletIcon
                name="show-chart"
                size={24}
                color="black"
              />
            ),
            infoTitle: "Total orders",
            info: orderData || 0,
            // bg: "#FFF5D0",
            bg: "rgba(255, 165, 0, 0.1)",
            color: "black",
          },
        ]);
      };

      dispatch(
        getTotalOrders({
          callback: {
            success: (data) => handleData(data),
            failure: () => handleData(0),
          },
        })
      );
    };

    dispatch(
      getTotalSales({
        callback: {
          success: (data) => handleSale(data),
          failure: () => handleSale(0),
        },
      })
    );

    dispatch(getTopSellingProducts());
    dispatch(getPendingCount());
    dispatch(getCancelledCount());
    dispatch(getDeliveredCount());
    dispatch(getShippedCount());
    dispatch(getPackedCount());
    dispatch(getAllCategory());
    dispatch(getAllProduct());
    dispatch(getAllStates());
    // dispatch(getProductByCategoryId({
    //     id : 16,
    //     callback : {
    //         success : (data) => console.log(data)
    //     }
    // }))
  }, []);

  // console.log(totalSale);
  // console.log(totalOrder);
  // console.log(topSellingProducts, "topSellingProducts");
  // console.log(pendingCount);
  // console.log(cancelledCount);
  // console.log(shippedCount);
  // console.log(packedCount);
  // console.log(deliveredCount);
  // console.log(categories, "categories");
  // console.log(productbyCategoryId, "productbyCategoryId");
  // console.log(products, "products");

  const handleProductByCategoryId = (id) => {
    dispatch(
      getProductByCategoryId({
        id: id,
        callback: {
          success: (data) => console.log(data),
        },
      })
    );
  };
  const getStructuredRows = (data = []) => {
    return data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <div
          style={{
            borderRadius: "50%",
            height: "50px",
            width: "50px",
            overflow: "hidden",
            marginLeft: "60px",
          }}
        >
          <img
            src={item?.image}
            alt="profile"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
          />
        </div>,
        getObjectFromArrayOfObjects(products, "id", item?.id)?.productCode,
        // item?.skuId,
        item?.name,
        item?.categories?.map((cat, i) => (
          <span key={i}>
            {cat}
            {i < item.categories.length - 1 && ", "}
          </span>
        )),
        item?.inStock,
        item?.unitsSold,
        item?.revenue,

        // <Button
        //   variant="outlined"
        //   className={styles.ovalButtonOut}
        //   disableRipple
        //   disableElevation
        //   onClick={() => handleNavigate(item)}
        // >
        //   {item?.orderCode || "NA"}
        // </Button>,
        // item?.cartBundleId,
        // getObjectFromArrayOfObjects(customers, "id", item?.customerId)
        //   ?.fullName || "NA",
        // handleBtn(item?.status),
      ],
    }));
  };

  const ordersData = [
    {
      id: "01",
      icon: (
        // <IconButton>
        <HourglassBottom />
        // </IconButton>
      ),
      heading: pendingCount?.pendingCount || 0,
      subHeading: "Placed",
      bg: "rgba(0, 153, 0, 0.1)",

      color: "#1C1B1F",
    },
    {
      id: "02",
      icon: (
        // <IconButton>
        <ViewInAr />
        // </IconButton>
      ),
      heading: packedCount?.packedCount || 0,
      subHeading: "Packed",
      bg: "rgba(255, 165, 0, 0.1)",
      color: "#1C1B1F",
    },
    {
      id: "03",
      icon: (
        // <IconButton>
        <LocalShippingIcon />
        // </IconButton>
      ),
      heading: shippedCount?.shippedCount || 0,
      subHeading: "shipped",
      bg: " rgba(143, 0, 255, 0.1)",
      color: "#1C1B1F",
    },
    {
      id: "04",
      icon: (
        // <IconButton>
        <InventoryIcon />
        // </IconButton>
      ),
      heading: deliveredCount?.deliveredCount || 0,
      subHeading: "delivered",
      bg: " rgba(0, 0, 255, 0.1)",
      color: "#1C1B1F",
    },
    // {
    //   id: "05",
    //   icon: (
    //     // <IconButton>
    //     <DisabledByDefaultIcon />
    //     // </IconButton>
    //   ),
    //   heading: cancelledCount?.cancelledCount || 0,
    //   subHeading: "cancelled",
    //   bg: "rgba(202, 229, 255, 1)",
    //   color: "#1C1B1F",
    // },
  ];

  const getStructuredOrdersStatusData = () =>
    // outForDelivery,
    // inTransit,
    // awaiting
    {
      return [
        {
          id: "01",
          icon: (
            <IconButton>
              <TableChart />
            </IconButton>
          ),
          // heading: outForDelivery || 0,
          subHeading: "out for delivery",
          bg: "#0099001A",
          color: "#1C1B1F",
        },
        {
          id: "02",
          icon: (
            <IconButton>
              <Storefront />
            </IconButton>
          ),
          // heading: inTransit || 0,
          subHeading: "in transits orders",
          bg: "#FFA5001A",
          color: "#1C1B1F",
        },
        {
          id: "03",
          icon: (
            <IconButton>
              <Storefront />
            </IconButton>
          ),
          // heading: awaiting || 0,
          subHeading: "awaiting Orders",
          bg: "#8F00FF1A",
          color: "#1C1B1F",
        },
      ];
    };

  const getUserDataMiniStat = () => {
    return [
      {
        id: "1",

        icon: <MovingIcon name="show-chart" size={24} color="black" />,
        infoTitle: "Total Sales",
        // info: sales || 0,
        bg: "#FFF5D0",
        color: "black",
      },
      {
        id: "2",
        icon: (
          <AccountBalanceWalletIcon name="show-chart" size={24} color="black" />
        ),
        infoTitle: "Total orders",
        // info:  || 0,
        bg: "#FFF5D0",
        color: "black",
      },
      // {
      //   id: "3",
      //   // icon: <Description name="show-chart" size={24} color="black" />,
      //   // infoTitle: "Total User",
      //   // info: 0,
      //   bg: "#FFF5D0",
      //   color: "black",
      // },
    ];
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Row className={styles.top}>
          <Col className={styles.topWrapper}>
            <MiniStat miniStatDatas={miniStatData} />
          </Col>
          {/* Orders overview */}

          {/* <Row className={styles.dashboardTileRow}>
            {ordersData.map((item) => (
              <Col
                className={styles.dashboardTileCol}
                key={item.id}
                xs={6}
                md={2}
              >
                <div className={styles.tileBox}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundColor: item.bg,
                      color: item.color,
                    }}
                  >
                    {item.icon}
                  </div>
                  <div className={styles.infoContainer}>
                    <div className={styles.heading}>{item.heading}</div>
                    <div className={styles.subHeading}>{item.subHeading}</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row> */}

          {/* orders overview */}
        </Row>
        <Row className={styles.row} style={{ margin: 0 }}>
          <DashboardTile
            title="orders Overview"
            //   subTitle={`Total ${totalOrders || 0} orders.`}
          >
            <Row className={styles.dashboardTileRow}>
              {ordersData.map((item) => (
                <Col className={styles.dashboardTileCol} key={item.id}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundColor: item.bg,
                      color: item.color,
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                    //   onClick={() => handlenavigation(item?.subHeading)}
                  >
                    {item.icon}
                  </div>
                  <div className={styles.infoContainer}>
                    <div className={styles.heading}>{item.heading}</div>
                    <div className={styles.subHeading}>{item.subHeading}</div>
                  </div>
                </Col>
              ))}
            </Row>
          </DashboardTile>
        </Row>
        {/* top selling product  */}
        <div className={styles.bottom}>
          <div className={styles.tableHeading}>Top Selling Products</div>
          <div style={{ borderRadius: "12px", overflow: "hidden" }}>
            <GenCustomTable
              columns={columns}
              rows={getStructuredRows(topSellingProducts)}
            />
          </div>
        </div>
        <Row className={styles.row}>
          <Col className={styles.col}>
            <DashboardTile title="Inventory">
              <ProductStocks maxHeight={300} />
            </DashboardTile>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedInUser: state?.login?.user,
    totalSale: state?.orders?.totalSale,
    totalOrder: state?.orders?.totalOrder,
    topSellingProducts: state?.product?.topSellingProducts,
    pendingCount: state?.orders?.pendingCount,
    cancelledCount: state?.orders?.cancelledCount,
    shippedCount: state?.orders?.shippedCount,
    packedCount: state?.orders?.packedCount,
    deliveredCount: state?.orders?.deliveredCount,
    products: state?.product?.products,
    // categories: state?.category?.categories,
    // productbyCategoryId: state?.product?.products,
    // productbyCategoryId : state?.product?.productsByCategory
  };
};

export default connect(mapStateToProps, null)(Dashboard);
